const FormatFileSize = (bytes) => {
    if (!bytes || isNaN(bytes)) return "0 Ko";
    const k = 1024;
    const sizes = ["Octets", "Ko", "Mo", "Go", "To"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
  
export default FormatFileSize;
  